export { default as useDevice } from './useDevice';
export * from './useDevice';

export { default as useGetLocalStorage } from './useGetLocalStorage';
export * from './useGetLocalStorage';

export { default as useOnClickOutside } from './useOnClickOutside';
export * from './useOnClickOutside';
